import React from "react";
import "./SkeletonLoader.css"; // Import CSS file for styling

const SkeletonLoader = () => {
  return (
    <div className="skeleton-loader ">
      <div className="skeleton-header bg-gray-800"></div>
      <div className="skeleton-content bg-gray-800"></div>
      <div className="skeleton-content bg-gray-800"></div>
      <div className="skeleton-content bg-gray-800"></div>
      <div className="skeleton-footer bg-gray-800 flex items-end">
        <span className="h-[75%] bg-gray-800 w-full rounded"></span>
      </div>
    </div>
  );
};

export default SkeletonLoader;
